import { configureStore } from '@reduxjs/toolkit';
import { useDispatch as useAppDispatch, useSelector as useAppSelector } from 'react-redux';
import { persistStore } from 'redux-persist';
import rootReducer from './reducer';

const reducerProxy = (state, action) => {
    if (action.type === 'common/setReset' && action.payload === true) {
        return rootReducer(undefined, action);
    }
    return rootReducer(state, action);
};

const store = configureStore({
    reducer: reducerProxy,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false })
});

const persister = persistStore(store);

const { dispatch } = store;

const useDispatch = () => useAppDispatch();
const useSelector = useAppSelector;

export { store, persister, dispatch, useSelector, useDispatch };
